const initPage = () => {
  const passwordIsNotSetModal = $('#modal-password-is-not-set');
  if (!passwordIsNotSetModal.length) {
    return;
  }
  const element = $('[data-show-modal-on-load]')[0];

  if (element) {
    let showModalOnLoad = element.dataset.showModalOnLoad;

    if(showModalOnLoad) {
      showModal();
      let modalBackdrop = (".modal-backdrop");
      if(modalBackdrop) {
        $(modalBackdrop).addClass('not-closable-modal')
      }
    }
  }
};

export const showModal = (redirectUrl = null) => {
  let regWallModal = $('#modal-apply-regwall');
  if(regWallModal.length) {
    regWallModal.modal('hide');
  }

  const passwordIsNotSetModal = $('#modal-password-is-not-set');
  $("#v-password-set-email", passwordIsNotSetModal).text($jBoard.currentUser.email);
  $($jBoard.currentUser.job_seeker_profile.reg_from_job_id ? "#modal-message-case-usual-registered" : "#modal-message-case-registered-via-regwall", passwordIsNotSetModal).remove();

  passwordIsNotSetModal.modal('show');

  let getCurrentUserInfoBtn = $("#get-current-user-info");

  getCurrentUserInfoBtn.click(async function() {
    getCurrentUserInfoBtn.loading();
    let response = await axios.get("/api/users/current");
    getCurrentUserInfoBtn.loading(false);

    if(response.data?.item?.password_is_set === false) {
      $('.missing-password-modal-error-message', passwordIsNotSetModal).removeClass('d-none');
    } else {
      if(redirectUrl) {
        getCurrentUserInfoBtn.loading();
        location.href = redirectUrl;
      } else {
        location.reload();
      }
    }
  })
}

$(initPage);
